(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tmd-collection-banner"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tmd-deal-banner')){customElements.define('tmd-deal-banner',class TmdDealBanner extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.startBase();

if(!this.querySelector('.deal-clock'))return;
const duration=((Number(this.dataset.days)*24+Number(this.dataset.hours))*60+Number(this.dataset.minutes))*60000;
let end;if(this.dataset.mode==='deadline'){end=Date.parse(this.dataset.deadline)}else{
 const key='tmd-campaign:'+this.dataset.campaign+':'+duration;
 try{const saved=localStorage.getItem(key);end=saved!==null?Number(saved):Date.now()+duration;if(saved===null)localStorage.setItem(key,String(end))}catch(e){end=Date.now()+duration}
}
if(!Number.isFinite(end)){this.querySelector('.deal-clock').hidden=true;this.querySelector('.deal-clock-label')?.setAttribute('hidden','');return}
const tick=()=>{const seconds=Math.max(0,Math.ceil((end-Date.now())/1000)),values={day:Math.floor(seconds/86400),hour:Math.floor(seconds%86400/3600),minute:Math.floor(seconds%3600/60),second:seconds%60};for(const [unit,value] of Object.entries(values))this.querySelector('[data-unit="'+unit+'"]').textContent=String(value).padStart(2,'0');if(seconds===0){this.querySelector('.deal-active').hidden=true;this.querySelector('.deal-expired').hidden=false;clearInterval(this.timer)}return seconds};if(tick()>0)this.timer=setInterval(tick,1000);

}

  startBase(){
    this.controller=new AbortController();this.opts={signal:this.controller.signal};
    const resize=()=>{if(this.dataset.fullWidth==='true')this.style.setProperty('--tmd-viewport',document.documentElement.clientWidth+'px')};resize();window.addEventListener('resize',resize,this.opts);
    if(this.dataset.reveal==='true'&&!window.Shopify?.designMode&&!matchMedia('(prefers-reduced-motion: reduce)').matches&&'IntersectionObserver' in window){
      this.classList.add('is-motion-ready');this.revealObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){if(entry.target===this){this.querySelectorAll('[data-reveal]').forEach((el,index)=>{el.style.transitionDelay=Math.min(index,4)*55+'ms';el.classList.add('is-visible')})}else entry.target.classList.add('is-visible');this.revealObserver.unobserve(entry.target)}}),{threshold:.08});if(this.dataset.revealAll==='true')this.revealObserver.observe(this);else this.querySelectorAll('[data-reveal]').forEach(el=>this.revealObserver.observe(el));
    }
  }
  disconnectedCallback(){this.controller?.abort();this.revealObserver?.disconnect();if(this.timer)clearInterval(this.timer);this.ready=false}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tmd-collection-benefits"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tmd-value-section')){customElements.define('tmd-value-section',class TmdValueSection extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.startBase();

}

  startBase(){
    this.controller=new AbortController();this.opts={signal:this.controller.signal};
    const resize=()=>{if(this.dataset.fullWidth==='true')this.style.setProperty('--tmd-viewport',document.documentElement.clientWidth+'px')};resize();window.addEventListener('resize',resize,this.opts);
    if(this.dataset.reveal==='true'&&!window.Shopify?.designMode&&!matchMedia('(prefers-reduced-motion: reduce)').matches&&'IntersectionObserver' in window){
      this.classList.add('is-motion-ready');this.revealObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){if(entry.target===this){this.querySelectorAll('[data-reveal]').forEach((el,index)=>{el.style.transitionDelay=Math.min(index,4)*55+'ms';el.classList.add('is-visible')})}else entry.target.classList.add('is-visible');this.revealObserver.unobserve(entry.target)}}),{threshold:.08});if(this.dataset.revealAll==='true')this.revealObserver.observe(this);else this.querySelectorAll('[data-reveal]').forEach(el=>this.revealObserver.observe(el));
    }
  }
  disconnectedCallback(){this.controller?.abort();this.revealObserver?.disconnect();if(this.timer)clearInterval(this.timer);this.ready=false}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tmd-collection-products"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tmd-collection-products')){customElements.define('tmd-collection-products',class TmdCollectionProducts extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.startBase();

this.classList.add('js-ready');const panel=this.querySelector('[data-filter-panel]');const backdrop=this.querySelector('[data-filter-backdrop]');const open=this.querySelector('[data-open-filters]');const small=()=>matchMedia('(max-width: 760px)').matches;
const closePanel=()=>{if(!panel)return;panel.classList.remove('is-open');backdrop.hidden=true;open?.setAttribute('aria-expanded','false');if(small())panel.inert=true};
const syncPanel=()=>{if(!panel)return;if(small())closePanel();else{panel.inert=false;panel.classList.remove('is-open');backdrop.hidden=true}};
syncPanel();window.addEventListener('resize',syncPanel,this.opts);
open?.addEventListener('click',()=>{panel.inert=false;panel.classList.add('is-open');backdrop.hidden=false;open.setAttribute('aria-expanded','true');panel.querySelector('[data-close-filters]')?.focus()},this.opts);
this.querySelector('[data-close-filters]')?.addEventListener('click',()=>{closePanel();open.focus()},this.opts);
backdrop?.addEventListener('click',()=>{closePanel();open.focus()},this.opts);
this.addEventListener('keydown',event=>{if(event.key==='Escape'&&panel?.classList.contains('is-open')){closePanel();open.focus()}},this.opts);
this.querySelector('[data-sort]')?.addEventListener('change',event=>event.target.form.requestSubmit(),this.opts);
const load=this.querySelector('[data-load-more]');load?.addEventListener('click',async event=>{
event.preventDefault();if(load.dataset.loading)return;load.dataset.loading='true';load.setAttribute('aria-disabled','true');
try{const url=new URL(load.href,location.href);url.searchParams.set('section_id',this.id.replace(/^TmdProducts-/,''));const response=await fetch(url,{headers:{Accept:'text/html'},signal:this.controller.signal});if(!response.ok)throw Error('load');const documentNext=new DOMParser().parseFromString(await response.text(),'text/html');const nextRoot=documentNext.querySelector('tmd-collection-products');if(!nextRoot)throw Error('section');const nextGrid=nextRoot.querySelector('[data-product-grid]');if(!nextGrid)throw Error('grid');const items=[...nextGrid.querySelectorAll('[data-product-card]')];if(!items.length)throw Error('empty');const grid=this.querySelector('[data-product-grid]');for(const card of items){card.classList.remove('is-visible');grid.appendChild(card);if(this.revealObserver)this.revealObserver.observe(card)}this.querySelector('[data-shown]').textContent=grid.querySelectorAll('[data-product-card]').length;const nextLink=nextRoot.querySelector('[data-load-more]');if(nextLink)load.href=new URL(nextLink.getAttribute('href'),location.href).href;else load.parentElement.remove();
}catch(error){if(error.name!=='AbortError')location.href=load.href}finally{delete load.dataset.loading;load.removeAttribute('aria-disabled')}
},this.opts);

}

  startBase(){
    this.controller=new AbortController();this.opts={signal:this.controller.signal};
    const resize=()=>{if(this.dataset.fullWidth==='true')this.style.setProperty('--tmd-viewport',document.documentElement.clientWidth+'px')};resize();window.addEventListener('resize',resize,this.opts);
    if(this.dataset.reveal==='true'&&!window.Shopify?.designMode&&!matchMedia('(prefers-reduced-motion: reduce)').matches&&'IntersectionObserver' in window){
      this.classList.add('is-motion-ready');this.revealObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){if(entry.target===this){this.querySelectorAll('[data-reveal]').forEach((el,index)=>{el.style.transitionDelay=Math.min(index,4)*55+'ms';el.classList.add('is-visible')})}else entry.target.classList.add('is-visible');this.revealObserver.unobserve(entry.target)}}),{threshold:.08});if(this.dataset.revealAll==='true')this.revealObserver.observe(this);else this.querySelectorAll('[data-reveal]').forEach(el=>this.revealObserver.observe(el));
    }
  }
  disconnectedCallback(){this.controller?.abort();this.revealObserver?.disconnect();if(this.timer)clearInterval(this.timer);this.ready=false}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tmd-footer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tmd-site-footer')){customElements.define('tmd-site-footer',class TmdSiteFooter extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.startBase();
const button=this.querySelector('[data-back-to-top]');button?.addEventListener('click',()=>window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}),this.opts);
}

  startBase(){
    this.controller=new AbortController();this.opts={signal:this.controller.signal};
    const resize=()=>{if(this.dataset.fullWidth==='true')this.style.setProperty('--tmd-viewport',document.documentElement.clientWidth+'px')};resize();window.addEventListener('resize',resize,this.opts);
    if(this.dataset.reveal==='true'&&!window.Shopify?.designMode&&!matchMedia('(prefers-reduced-motion: reduce)').matches&&'IntersectionObserver' in window){
      this.classList.add('is-motion-ready');this.revealObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){if(entry.target===this){this.querySelectorAll('[data-reveal]').forEach((el,index)=>{el.style.transitionDelay=Math.min(index,4)*55+'ms';el.classList.add('is-visible')})}else entry.target.classList.add('is-visible');this.revealObserver.unobserve(entry.target)}}),{threshold:.08});if(this.dataset.revealAll==='true')this.revealObserver.observe(this);else this.querySelectorAll('[data-reveal]').forEach(el=>this.revealObserver.observe(el));
    }
  }
  disconnectedCallback(){this.controller?.abort();this.revealObserver?.disconnect();if(this.timer)clearInterval(this.timer);this.ready=false}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tmd-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tmd-site-header')) {
  customElements.define('tmd-site-header', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.menuDialog = this.querySelector('[data-menu-dialog]');
      this.cartDialog = this.querySelector('[data-cart-dialog]');
      this.searchPanel = this.querySelector('[data-search-panel]');
      this.menuButton = this.querySelector('[data-menu-open]');
      this.cartButton = this.querySelector('[data-cart-open]');
      this.searchButtons = [...this.querySelectorAll('[data-search-toggle]')];

      const setSearch = (open, focusInput = false) => {
        this.searchPanel.hidden = !open;
        this.searchButtons.forEach(button => button.setAttribute('aria-expanded', String(open)));
        if (open && focusInput) this.searchPanel.querySelector('input[type="search"]')?.focus();
      };

      const onScroll = () => {
        this.classList.toggle('is-scrolled', window.scrollY > 12);
        this.classList.toggle('is-compact', window.scrollY > 110);
      };
      window.addEventListener('scroll', onScroll, { passive: true, signal });
      onScroll();

      this.menuButton?.addEventListener('click', () => {
        setSearch(false);
        this.menuDialog.showModal();
      }, { signal });
      this.querySelector('[data-menu-close]')?.addEventListener('click', () => this.menuDialog.close(), { signal });
      this.menuDialog?.addEventListener('close', () => this.menuButton?.focus(), { signal });

      this.cartButton?.addEventListener('click', () => {
        setSearch(false);
        this.cartDialog.showModal();
        this.refreshCart();
      }, { signal });
      this.querySelector('[data-cart-close]')?.addEventListener('click', () => this.cartDialog.close(), { signal });
      this.cartDialog?.addEventListener('close', () => this.cartButton?.focus(), { signal });

      [this.menuDialog, this.cartDialog].forEach(dialog => {
        dialog?.addEventListener('click', event => {
          if (event.target === dialog) dialog.close();
        }, { signal });
      });

      this.querySelectorAll('[data-submenu-toggle]').forEach(button => {
        button.addEventListener('click', () => {
          const panel = this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
          if (!panel) return;
          panel.hidden = !panel.hidden;
          button.setAttribute('aria-expanded', String(!panel.hidden));
        }, { signal });
      });

      this.searchButtons.forEach(button => {
        button.addEventListener('click', () => setSearch(this.searchPanel.hidden, true), { signal });
      });
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) setSearch(false);
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.searchPanel.hidden) {
          setSearch(false);
          this.searchButtons.find(button => button.getClientRects().length)?.focus();
        }
      }, { signal });

      ['cart:updated', 'cart:refresh', 'cart:change'].forEach(name => {
        document.addEventListener(name, () => this.refreshCart(), { signal });
      });
      window.addEventListener('pageshow', () => this.refreshCart(), { signal });
    }

    async refreshCart() {
      if (!this.isConnected || !this.dataset.sectionId) return;
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      try {
        const response = await fetch(url.toString(), {
          credentials: 'same-origin', cache: 'no-store', signal: this.controller.signal
        });
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = doc.querySelector('tmd-site-header');
        if (!fresh || !this.isConnected) return;
        const count = fresh.querySelector('[data-cart-count]');
        const view = fresh.querySelector('[data-cart-view]');
        const freshButton = fresh.querySelector('[data-cart-open]');
        if (count) this.querySelector('[data-cart-count]').textContent = count.textContent;
        if (view) this.querySelector('[data-cart-view]').innerHTML = view.innerHTML;
        if (freshButton) this.cartButton.setAttribute('aria-label', freshButton.getAttribute('aria-label'));
      } catch (error) {
        if (error.name === 'AbortError') return;
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this._ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
